import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class NationalAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'Nationals';

  all = 'all';

  request = 'request';

  employees = 'employees';

  tickets = 'tickets';

  partner = 'partner';

  async getNationals() {
    let request = {
      url: [this.getAPIUrl(), this.all].join('/'),
    };

    return await httpClient.getAsync(request);
  }
  async getNationalRequest() {
    let request = {
      url: [this.getAPIUrl(), this.request].join('/'),
    };

    return await httpClient.getAsync(request);
  }
  async getNationalEmployee() {
    let request = {
      url: [this.getAPIUrl(), this.employees].join('/'),
    };

    return await httpClient.getAsync(request);
  }

  async getNationalTicket() {
    let request = {
      url: [this.getAPIUrl(), this.tickets].join('/'),
    };
    return await httpClient.getAsync(request);
  }

  async getNationalPartner() {
    let request = {
      url: [this.getAPIUrl(), this.partner].join('/'),
    };
    return await httpClient.getAsync(request);
  }
}

export default new NationalAPI();
